import React, { useEffect, useState } from 'react'
import SuccessStory from '../../CertificateVerification/SuccessStory'
import PlacementSuccessStory from '../../../components/PlacementSuccessStory'
import Faq from '../../CertificateVerification/Faq'
import NewRecognisedSection from '../../../components/NewRecognisedSection'
import LcpCourse from './LcpCourse'
import ChooseNextCourse from './ChooseNextCourse'
import { dispatchUserPersonaliseCourseSelection, fetchPaymentId, fetchRazorPayStatus, fetchUnqiueUserUUID, fetchUserUUID } from '../../../redux/actions/personaliseCourse'
import { useDispatch, useSelector } from 'react-redux'
import { RAZORPAY_KEY } from '../../../config/api_config'
import useRazorpay from 'react-razorpay'
import { capitalizeWords } from '../../../utils/subscription'
import { SET_ONBOARDING_SUCCESS_UUID } from '../../../redux/actions/types'
import { Mixpanel } from '../../../config/Mixpanel'
import Constants from '../../../common/constants'
import OnBoardingFaq from '../onBoardingFaq'

const Course = ({ handleOnboardingCompletion, handleSetIsLoading, handleOnboardingCompletionWithoutRedirection }) => {
    const [swiperInstance, setSwiperInstance] = useState(null)
    const dispatch = useDispatch()
    const email = useSelector(store => store?.profileDetails?.email)
    const phoneNumber = useSelector(state => state?.profileDetails?.['phone-number'])
    const skillName = useSelector(state => state?.onBoarding?.selectedSkill?.['skill-name'])
    const userName = useSelector(state => state?.profileDetails?.name)
    const firstName = useSelector(state => state?.profileDetails?.first_name)
    const Razorpay = useRazorpay()


    useEffect(() => {
        Mixpanel.track(Constants.Mixpanel.ONBOARDING_PAGE_25_COURSE_PAGE_LOADED);
    }, []);

    const razorpayHandler = async (callback) => {
        dispatch(fetchUserUUID(userName, email, phoneNumber, skillName, successObj => {
            dispatch(fetchPaymentId(successObj?.uuid, 399, "Personalise Course", successObject => {
                const options = {
                    key: RAZORPAY_KEY,
                    amount: `${399 * 100}`,
                    currency: "INR",
                    name: skillName,
                    description: "Personalise Course",
                    order_id: successObject?.razorpay_order_id,
                    modal: {
                        "ondismiss": function () {
                            callback()
                        }
                    },
                    handler: (res) => {
                        getOrderStatusSuccess(successObj?.uuid, res)
                        callback();
                    },
                    prefill: {
                        name: userName,
                        email: email,
                        contact: phoneNumber,
                    },
                    theme: {
                        color: "#26CBA7"
                    }
                }
                const razorpayInitializor = new Razorpay(options)
                razorpayInitializor.on("payment.failed", function (response) {
                    getOrderStatusFailure(successObj?.uuid, response)
                    callback()
                })
                razorpayInitializor.open()
            }, (err) => {
                dispatch(fetchUnqiueUserUUID(userName, email, phoneNumber, skillName, successObj => {
                    dispatch(fetchPaymentId(successObj?.uuid, 399, "Personalise Course", successObject => {
                        const options = {
                            key: RAZORPAY_KEY,
                            amount: `${399 * 100}`,
                            currency: "INR",
                            name: skillName,
                            description: "Personalise Course",
                            order_id: successObject?.razorpay_order_id,
                            modal: {
                                "ondismiss": function () {
                                    callback()
                                }
                            },
                            handler: (res) => {
                                getOrderStatusSuccess(successObj?.uuid, res)
                                callback();
                            },
                            prefill: {
                                name: userName,
                                email: email,
                                contact: phoneNumber,
                            },
                            theme: {
                                color: "#26CBA7"
                            }
                        }
                        const razorpayInitializor = new Razorpay(options)
                        razorpayInitializor.on("payment.failed", function (response) {
                            getOrderStatusFailure(successObj?.uuid, response)
                            callback()
                        })
                        razorpayInitializor.open()
                    }))
                }))
            }))

        }))

    }

    const getOrderStatusSuccess = async (uuid, response) => {

        dispatch({ type: SET_ONBOARDING_SUCCESS_UUID, payload: uuid })
        Mixpanel.track(Constants.Mixpanel.ONBOARDING_PAGE_25_COURSE_PAGE_SUBSCRIPTION_PURCHASED);
        await dispatch(fetchRazorPayStatus({
            uuid: uuid,
            payment_id: response?.razorpay_payment_id,
            order_id: response?.razorpay_order_id,
            isError: false,
            razorpay_signature: response?.razorpay_signature,
            errorObj: {}
        }))
        await dispatch(dispatchUserPersonaliseCourseSelection(true))
        handleOnboardingCompletionWithoutRedirection()
        handleSetIsLoading(true);
    }

    const getOrderStatusFailure = async (uuid, response) => {
        dispatch(fetchRazorPayStatus({
            uuid: uuid,
            payment_id: response?.error?.metadata?.payment_id,
            order_id: response?.error?.metadata?.order_id,
            isError: true,
            razorpay_signature: "",
            errorObj: { ...response?.error }
        }))
    }

    return (
        <div className='w-full'>
            <div className='font-semibold leading-[130%] text-[28px] text-center text-[#DED996] tracking-[-0.1]'>Master {capitalizeWords(skillName)} with a Course Built by Experts to Land Your Next Job</div>
            <div className='mt-8'>
                <LcpCourse razorpayHandler={razorpayHandler} handleOnboardingCompletion={handleOnboardingCompletion} />
            </div>
            <div className='mt-12 text-center'>
                <div className='text-[16px]  text-white/50'>What Your Career Could Look Like</div>
                <div className='text-[24px] font-semibold text-white leading-[130%]'>In Just 4 Weeks, {firstName}!</div>
                <img alt="" className='w-full mt-4' src="https://storage.googleapis.com/learntube-web-assets/files/OnBoardingPage/Frame%20427322063%20(1).png" />
            </div>
            <div className='mt-10'>
                <NewRecognisedSection swiperInstance={swiperInstance} setSwiperInstance={setSwiperInstance} />
            </div>
            <div className='mt-12 text-center'>
                <div className='text-[16px]  text-white/50'>What You’ll Get</div>
                <div className='text-[24px] font-semibold text-white leading-[130%]'>Everything To Master {capitalizeWords(skillName)}</div>
                <img alt="" className='w-full mt-4' src="https://storage.googleapis.com/learntube-web-assets/files/OnBoardingPage/Component%20150.webp" />
            </div>
            <div className='mt-12'>
                <ChooseNextCourse handleOnboardingCompletion={handleOnboardingCompletion} razorpayHandler={razorpayHandler} />
            </div>
            <div className='mt-12 w-full flex flex-col items-center justify-center text-center'>
                <div className='text-[16px]  text-white/50'>Success Stories</div>
                <div className='text-[24px] font-semibold text-white mb-4 leading-[130%]'>Real Learners, Real Outcomes</div>
                <PlacementSuccessStory />
            </div>
            <div className='mt-12'>
                <SuccessStory />
            </div>
            <div className="mt-12 mb-4 text-center text-[24px] font-semibold text-white">
                Frequently{" "}
                <span className=""> Asked </span>{" "}
                Questions
            </div>
            <OnBoardingFaq />

        </div>
    )
}

export default Course